/* eslint-disable react/react-in-jsx-scope */

import { useEffect, useRef, useState } from 'react';
import './App.css';

import 'animate.css';

import Info from './components/Info';
import Sign from './components/Sign';
import Snack from './components/Snack';
import VendingMachine from './components/VendingMachine';
import Bck from './spritesheets/bckrnd.png';

import { EnteredProvider } from './context/EnteredContext';

import displaySprite from './spritesheets/display.png';
import iep from './spritesheets/iep.png';
import internchips from './spritesheets/internchips.png';
import pxart from './spritesheets/pixel-art.png';
import rex from './spritesheets/rexflection.png';
import skills from './spritesheets/skills.png';
import start1 from './spritesheets/start1.png';
import start2 from './spritesheets/start2.png';
import sts from './spritesheets/sts.png';
import westernChip from './spritesheets/western-chips.png';
import wtf from './spritesheets/wtf.png';

import info1 from './spritesheets/info1.png';
import info2 from './spritesheets/info2.png';

import mail1 from './spritesheets/mail1.png';
import mail2 from './spritesheets/mail2.png';

import bckBtn from './spritesheets/bckBtn.png';
import bckdiv from './spritesheets/bckdiv.png';

import lnkdin1 from './spritesheets/lnkdin1.png';
import lnkdin2 from './spritesheets/lnkdin2.png';

import house1 from './spritesheets/house1.png';
import house2 from './spritesheets/house2.png';

import question1 from './spritesheets/question1.png';
import question2 from './spritesheets/question2.png';

import acc1 from './spritesheets/acc1.png';
import acc2 from './spritesheets/acc2.png';

import text1 from './spritesheets/text1.png';
import text2 from './spritesheets/text2.png';

import vendBck from './spritesheets/vendbck.png';

import 'animate.css';
import MobileSign from './components/MobileSign';
import Keyboard from './components/Keyboard';

function App() {
  const width = 160 * 2;
  const height = 248 * 2;

  const displayRef = useRef(null);
  const displayCtx = useRef(null);

  const displayImg = useRef(new Image());

  const [isHovered, setIsHovered] = useState(false);

  const [play, setPlay] = useState(1);
  const [info, setInfo] = useState(1);
  const [mail, setMail] = useState(1);
  const [acc, setAcc] = useState(1);
  const [lnk, setLnk] = useState(1);
  const [home, setHome] = useState(1);
  const [question, setQuestion] = useState(1);
  const [text, setText] = useState(1);

  const [font, setFont] = useState('slkscr');
  const [vendState, setVendState] = useState(false);
  const [openInfo, setOpenInfo] = useState(false);
  const [openText, setOpenText] = useState(false);

  const [openAcc, setOpenAcc] = useState(false);
  const [animations, setAnimations] = useState('animate__animated');

  useEffect(() => {
    const display = displayRef.current;
    displayCtx.current = display.getContext('2d');

    displayImg.current.src = displaySprite;

    displayImg.current.onload = () => {
      displayCtx.current.drawImage(
        displayImg.current, // image of spritesheet
        0 * width,
        0, // cut from spritesheet
        width,
        height, // sw, sh (size of sprite)
        0,
        0, // dx, dy
        width,
        height // dw, dh (size on canvas)
      );
    };
  }, []);

  const screenState = () => {
    setVendState(!vendState);
  };

  return (
    <EnteredProvider>
      <div
        style={{
          backgroundImage: `url(${vendBck})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          fontFamily: font
        }}>
        <div
          style={{
            backgroundImage: vendState ? `` : `url(${Bck})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center'
          }}
          className={vendState ? 'hidden' : 'relative h-screen w-screen'}>
          <div className="flex flex-col gap-2 h-screen w-screen z-25 relative justify-center items-center">
            <img
              src={play === 1 ? start1 : start2}
              alt="Start Button"
              onMouseEnter={() => setPlay(2)}
              onMouseLeave={() => setPlay(1)}
              onClick={() => {
                screenState();
              }}
            />
            <div className="flex gap-2">
              <img
                src={info === 1 ? info1 : info2}
                alt="Info"
                onMouseEnter={() => setInfo(2)}
                onMouseLeave={() => setInfo(1)}
                onClick={() => {
                  setOpenInfo(true);
                }}
              />
              <a href="https://www.linkedin.com/in/angela-deng32/">
                <img
                  src={lnk === 1 ? lnkdin1 : lnkdin2}
                  alt="LinkedIn"
                  onMouseEnter={() => setLnk(2)}
                  onMouseLeave={() => setLnk(1)}
                />
              </a>
              <img
                src={mail === 1 ? mail1 : mail2}
                alt="Send Email"
                onMouseEnter={() => setMail(2)}
                onMouseLeave={() => setMail(1)}
                onClick={() => {
                  window.location.href = 'mailto:angeladeng423@gmail.com';
                }}
              />

              <img
                src={acc === 1 ? acc1 : acc2}
                alt="Send Email"
                onMouseEnter={() => setAcc(2)}
                onMouseLeave={() => setAcc(1)}
                onClick={() => {
                  setFont(font === 'slkscr' ? 'arial' : 'slkscr');
                  setAnimations(animations === 'animate__animated' ? '' : 'animate__animated');
                  setOpenAcc(true);
                }}
              />
            </div>
          </div>

          <div
            className={
              openAcc ? 'absolute inset-0 flex justify-center items-center z-100' : 'hidden'
            }>
            <div
              className={`w-[400px] h-[324px] flex flex-col p-6 gap-6 text-center justify-center items-center md:w-[400px] md:h-[324px] md:text-base ${animations} animate__bounceInLeft`}
              style={{
                backgroundImage: `url(${bckdiv})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center'
              }}>
              <div
                className={`cursor-pointer  ${animations} ${isHovered ? 'animate__headShake' : ''}`}
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}>
                <img src={bckBtn} alt="Return" onClick={() => setOpenAcc(false)} />
              </div>
              <div>
                Font is toggled to {font} & animations are turned{' '}
                {animations === 'animate__animated' ? 'on' : 'off'}.
              </div>
            </div>
          </div>
          <div
            className={
              openInfo ? 'absolute inset-0 flex justify-center items-center z-100' : 'hidden'
            }>
            <div
              className={`w-[400px] h-[324px] flex flex-col p-6 gap-6 text-center justify-center items-center md:w-[400px] md:h-[324px] md:text-base ${animations} animate__bounceInLeft`}
              style={{
                backgroundImage: `url(${bckdiv})`,
                backgroundSize: 'cver',
                backgroundPositiono: 'center'
              }}>
              <div
                className={`cursor-pointer ${animations} ${isHovered ? 'animate__headShake' : ''}`}
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}>
                <img src={bckBtn} alt="Return" onClick={() => setOpenInfo(false)} />
              </div>
              <div>
                Hi! My name is Angela Deng!
                <br /> <br />
                I’m a software developer and pixel artist! Click "Start" to explore my portfolio.
                All pixel art displayed on this site is my own work. Icons from{' '}
                <u>
                  <a href="https://leo-red.itch.io/lucid-icon-pack">Lucid Icons.</a>
                </u>
              </div>
            </div>
          </div>
        </div>

        <div
          className={
            vendState
              ? 'flex flex-col items-center md:justify-center gap-4 min-h-screen min-w-screen'
              : 'hidden'
          }>
          <Info css="hidden" animated={animations} />

          <div
            className={
              openInfo ? 'z-50 absolute inset-0 flex justify-center items-center z-100' : 'hidden'
            }>
            <div
              className={`w-[400px] h-[324px] flex flex-col p-6 gap-6 text-center justify-center items-center md:w-[400px] md:h-[324px] md:text-base ${animations} animate__bounceInLeft`}
              style={{
                backgroundImage: `url(${bckdiv})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center'
              }}>
              <div
                className={`cursor-pointer ${animations} ${isHovered ? 'animate__headShake' : ''}`}
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}>
                <img src={bckBtn} alt="Return" onClick={() => setOpenInfo(false)} />
              </div>
              <div>
                <div class="text-left">
                  <b>AB2:</b> Internchips <br></br>
                  <b>BC4:</b> Education <br></br>
                  <b>DB3:</b> Project - WhatTheFlora <br></br>
                  <b>AD1:</b> Project - InEnglishPlease <br></br>
                  <b>BA3:</b> Project - Rexflection <br></br>
                  <b>DC1:</b> Technology & Skills <br></br>
                  <b>BD2:</b> About Me! <br></br>
                  <b>CB4:</b> Pixel Art <br></br>
                </div>
              </div>
            </div>
          </div>

          <div className={`mt-4 flex gap-4 ${animations} animate__bounceInDown`}>
            <img
              src={home === 1 ? house1 : house2}
              alt="Home Button"
              onMouseEnter={() => setHome(2)}
              onMouseLeave={() => setHome(1)}
              onClick={() => {
                screenState();
              }}></img>

            <img
              src={question === 1 ? question1 : question2}
              alt="Information Button"
              onMouseEnter={() => setQuestion(2)}
              onMouseLeave={() => setQuestion(1)}
              onClick={() => {
                setOpenInfo(true);
              }}></img>

            <img
              src={text === 1 ? text1 : text2}
              alt="Information Button"
              onMouseEnter={() => setText(2)}
              onMouseLeave={() => setText(1)}
              onClick={() => {
                setOpenText(!openText);
              }}></img>
          </div>

          <div className={`relative ${animations} animate__bounceInDown`}>
            <canvas
              className="absolute top-0 z-40"
              ref={displayRef}
              width={108 * 2}
              height={188 * 2}></canvas>
            <Sign css="hidden md:block absolute top-0 z-0" />
            <VendingMachine css="relative z-20 " />
            <Snack
              image={internchips}
              css="absolute top-0 z-20 "
              width={108 * 2}
              height={186 * 2}
              itemW={21 * 2}
              itemH={21 * 2}
              x={17 * 2}
              y={41 * 2}
              trigger="AB2"
            />
            <Snack
              image={westernChip}
              css="absolute top-0 z-20 "
              width={108 * 2}
              height={186 * 2}
              itemW={21 * 2}
              itemH={21 * 2}
              x={42 * 2}
              y={41 * 2}
              trigger="BC4"
            />
            <Snack
              image={wtf}
              css="absolute top-0 z-20 "
              width={108 * 2}
              height={186 * 2}
              itemW={15 * 2}
              itemH={24 * 2}
              x={22 * 2}
              y={71 * 2}
              trigger="DB3"
            />
            <Snack
              image={iep}
              css="absolute top-0 z-20 "
              width={108 * 2}
              height={186 * 2}
              itemW={15 * 2}
              itemH={24 * 2}
              x={44 * 2}
              y={71 * 2}
              trigger="AD1"
            />
            <Snack
              image={rex}
              css="absolute top-0 z-20 "
              width={108 * 2}
              height={186 * 2}
              itemW={15 * 2}
              itemH={24 * 2}
              x={83 * 2}
              y={71 * 2}
              trigger="BA3"
            />
            <Snack
              image={skills}
              css="absolute top-0 z-20 "
              width={108 * 2}
              height={186 * 2}
              itemW={17 * 2}
              itemH={24 * 2}
              x={62 * 2}
              y={104 * 2}
              trigger="DC1"
            />
            <Snack
              image={sts}
              css="absolute top-0 z-20 "
              width={108 * 2}
              height={186 * 2}
              itemW={21 * 2}
              itemH={26 * 2}
              x={43 * 2}
              y={135 * 2}
              trigger="BD2"
            />

            <Snack
              image={pxart}
              css="absolute top-0 z-20 "
              width={108 * 2}
              height={186 * 2}
              itemW={17 * 2}
              itemH={24 * 2}
              x={82 * 2}
              y={137 * 2}
              trigger="CB4"
            />

            <div
              className={
                openText ? `${animations} animate__bounceIn flex justify-center mt-4` : 'hidden'
              }>
              <Keyboard />
            </div>
          </div>
        </div>
      </div>
    </EnteredProvider>
  );
}
export default App;
